module.exports = __webpack_public_path__ + "static/media/shrubnub-home.3b8473b8.png";